<template>
<div v-if="page.career" class="page page-white page-career">
  <div class="container">
    <CareerMainText/>
  </div>
 </div>
</template>

<script>
import { mapGetters } from 'vuex';

import CareerMainText from '@/components/CareerMainText';

export default {
  name: 'career',
  computed: mapGetters({
    careerSlide: 'careerSlide',
    page: 'page',
  }),
  components: {
    CareerMainText,
  },
};
</script>


<style>
.page-career{

  .career-growth{
    margin-top: 40px;
  }

  &--switcher{
    margin-top: 50px;
    line-height: 1;
  }

  &--switch{
    border-top: solid 2px transparent;
    transition: all .3s ease-in-out;
    padding: 3px 9px;
    display: inline-block;
    vertical-align: top;
    margin-right: 8px;
    border-radius: 3px;
    cursor: pointer;

    @media (max-width: $mediaMob) {
      margin: 4px 4px 4px 0;
    }

    &-active,
    &:hover{
      background: #26a1d1;
      color: white;
    }

    &-active{
      &,
      &:hover{
         background: #ff9933;
         cursor: auto;
      }
    }

    &.uppercase{
       font-size: 110%;
    }
  }

  &--stages{
    min-height: 300px;
    /*min-width: 300px;*/
    max-width: 70%;

    @media (max-width: 1500px) {
      min-height: 400px;
      max-width: 50%;
    }

    @media (max-width: $mediaIpad) {
      max-width: 70%;
      min-height: 380px;
    }

    @media (max-width: $mediaTiny) {
      max-width: 100%;
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Career.vue